export default {
  GET: 'VOD.ITEM.GET',
  CREATE: 'VOD.ITEM.CREATE',
  UPDATE: 'VOD.ITEM.UPDATE',
  REUPLOAD: 'VOD.ITEM.REUPLOAD',
  UPLOAD: 'VOD.ITEM.UPLOAD',
  GET_VIDEO_URLS: 'VOD.ITEM.GET_VIDEO_URLS',
  GET_VIDEO_URLS_BY_FILE_NAME: 'VOD.ITEM.GET_VIDEO_URLS_BY_FILE_NAME',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/item.js